import { createSelector } from 'reselect'
import moment from 'moment'

import { toHslaString } from '@imodules/react-components/forms/shared'
import { donorRollStyles } from './functions'

export const getDonorRollConfiguration = (state: RootState) => state.donorRoll

export const getDonorRollInstanceSettings = createSelector(getDonorRollConfiguration, donorRollConfiguration => donorRollConfiguration && donorRollConfiguration.instanceSettings)

export const getDonorRollLayoutSettings = createSelector(getDonorRollInstanceSettings, settings => settings && settings.layoutSettings)

export const getDonorAvatarStyles = createSelector(getDonorRollInstanceSettings, instanceSettings => {
    if (instanceSettings) {
        switch (instanceSettings.layoutSettings.donorAvatarType) {
            case ('FirstInitial'): {
                const css: React.CSSProperties = {
                    backgroundColor: toHslaString(instanceSettings.layoutSettings.donorAvatarFirstInitialBackgroundColor),
                    color: toHslaString(instanceSettings.layoutSettings.donorAvatarFirstInitialFontColor),
                }
                return css
            }
            case ('Image'): {
                const css: React.CSSProperties = { backgroundImage: `url(data:image;base64,${instanceSettings.layoutSettings.donorAvatarImage})` }
                return css
            }
            default: return undefined
        }
    }
    return undefined
})

export const getTitleTextStyle = createSelector(getDonorRollInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.titleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.titleColor),
    fontStyle: instanceSettings.layoutSettings.titleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.titleBold ? 'bold' : 'normal',
})

export const getSubTitleTextStyle = createSelector(getDonorRollInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.subTitleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.subTitleColor),
    fontStyle: instanceSettings.layoutSettings.subTitleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.subTitleBold ? 'bold' : 'normal',
})

export const getDonorRollDataGridStyleOptions = createSelector(getDonorRollInstanceSettings, instanceSettings => instanceSettings && {
    evenStyle: donorRollStyles(
        instanceSettings.layoutSettings.backgroundEvenColor,
        instanceSettings.layoutSettings.fontEvenColor,
        instanceSettings.layoutSettings.fontSize),
    oddStyle: donorRollStyles(
        instanceSettings.layoutSettings.backgroundOddColor,
        instanceSettings.layoutSettings.fontOddColor,
        instanceSettings.layoutSettings.fontSize),
})

export const getDataGridEvenOptions = createSelector(getDonorRollDataGridStyleOptions, options => options && options.evenStyle)
export const getDataGridOddOptions = createSelector(getDonorRollDataGridStyleOptions, options => options && options.oddStyle)

export const getDonorRollData = createSelector(getDonorRollConfiguration, donorRollState => donorRollState && donorRollState.data)

export const getDonorRollDisplayEndDateTime = createSelector(getDonorRollInstanceSettings, settings => settings && settings.displayEndDateTime && moment(settings.displayEndDateTime))

export const getDonorRollDisplayStartDateTime = createSelector(getDonorRollInstanceSettings, settings => settings && moment(settings.displayStartDateTime))

export const getDonorRollOverrideDisplayLimit = createSelector(getDonorRollConfiguration, donorRollState => donorRollState && donorRollState.overrideDisplayLimit)

export const getShowModule = createSelector(getDonorRollDisplayEndDateTime, getDonorRollDisplayStartDateTime, (displayEndDateTime, displayStartDateTime) =>
    moment().isAfter(displayStartDateTime) && (!displayEndDateTime || moment().isBefore(displayEndDateTime)))

export const getAnonymousDonorVerbiage = createSelector(getDonorRollLayoutSettings, settings => settings && settings.anonymousDonorVerbiage)

export const getAnonymousAmountVerbiage = createSelector(getDonorRollLayoutSettings, settings => settings && settings.anonymousAmountVerbiage)

export const getDesignationVerbiage = createSelector(getDonorRollLayoutSettings, settings => settings && settings.designationVerbiage)

export const getIncludeDesignation = createSelector(getDonorRollLayoutSettings, settings => settings && settings.includeDesignation)
